import { render, staticRenderFns } from "./RegistrarmeEmpadronamiento.vue?vue&type=template&id=780153de&scoped=true&"
import script from "./RegistrarmeEmpadronamiento.vue?vue&type=script&lang=js&"
export * from "./RegistrarmeEmpadronamiento.vue?vue&type=script&lang=js&"
import style0 from "./RegistrarmeEmpadronamiento.vue?vue&type=style&index=0&id=780153de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780153de",
  null
  
)

export default component.exports